import React from "react";

import { Button, Toast } from "@newsela/angelou";
import { func, object } from "prop-types";

import { confirmationModalButtonsCss } from "@/admin/AdminContentSettingsSearchFormOverlay/AdminContentSettingsSearchFormOverlay.style";
import useContentItemVisibilityPost from "@/admin/hooks/useContentItemVisibilityPost";
import globalToasterRef from "@/base/globalToasterRef";
import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";

const propTypes = {
  reset: func.isRequired,
  trigger: func.isRequired,
  handleSubmit: func.isRequired,
  articleChanges: object.isRequired,
  invokeContentSettingsSearchModeChange: func.isRequired,
};

const AdminContentSettingsSearchFormOverlayButtons = ({
  reset,
  trigger,
  handleSubmit,
  articleChanges,
  invokeContentSettingsSearchModeChange,
}) => {
  // initialize everything needed from the context provider
  const {
    disableContentSettingsRef,
    applyPermissionsModalProps: { closeModal },
  } = useAdminContentSettingsContext();

  // initialize the Request to submit the Content Selections
  const [postContentItemSelections] = useContentItemVisibilityPost();

  const postToContentItemVisibility = async (visiblityData, formData) => {
    try {
      const response = await postContentItemSelections(visiblityData);
      if (response.error) {
        // TODO: extract toasts to types
        globalToasterRef.current.displayToast({
          showIcon: true,
          statusColor: Toast.statusColor.danger,
          children: response.error.message,
        });
        return;
      }
      if (response.data) {
        // TODO: extract to toast types
        globalToasterRef.current.displayToast({
          children: "Visibility permissions saved.",
          statusColor: Toast.statusColor.success,
        });
        // clean the form, but not pristine
        // keep their values to hide the viz marker cache TTL
        reset({ ...formData });
      }
    } catch {
      // TODO: extract toasts to types
      globalToasterRef.current.displayToast({
        showIcon: true,
        statusColor: Toast.statusColor.danger,
        children:
          "There was an error saving your selections. Please try again.",
      });
    }
  };

  // Submission callback
  // react-hook-form `handleSubmit` will use this
  const onSubmit = (data) => {
    postToContentItemVisibility(articleChanges, data);
  };

  return (
    <div css={confirmationModalButtonsCss}>
      <Button
        objectType="User"
        actionPrefix="Cancel"
        actionName="Navigate"
        onClick={() => {
          closeModal();
          // TODO: move these to onSuccess callbacks
          // user was trying to leave Content Settings;
          // let them leave
          invokeContentSettingsSearchModeChange();

          // TODO: ???
          // disableContentSettingsRef.current = false;

          // make the form pristine, back to default values
          reset();
        }}
        flavor={Button.flavors.secondary}
      >
        Discard changes
      </Button>

      <Button
        // TODO: eventStream props or something??
        objectType="User" // ???
        actionPrefix="Initiate" // ???
        actionName="Delete" // ???
        onClick={() => {
          closeModal();
          // trigger react-hook-form submission
          trigger().then((isValid) => {
            if (isValid) {
              handleSubmit(onSubmit)();
            }
          });

          // TODO: extract to onSuccess callback
          // user was trying to leave;
          // so let them go
          invokeContentSettingsSearchModeChange();
          disableContentSettingsRef.current = false;
        }}
        flavor={Button.flavors.primary}
      >
        Apply permissions
      </Button>
    </div>
  );
};

AdminContentSettingsSearchFormOverlayButtons.propTypes = propTypes;
AdminContentSettingsSearchFormOverlayButtons.displayName =
  "AdminContentSettingsSearchFormOverlayButtons";
export { AdminContentSettingsSearchFormOverlayButtons };
